import { render, staticRenderFns } from "./DetailWoCard.vue?vue&type=template&id=16f6a5a2"
import script from "./DetailWoCard.vue?vue&type=script&lang=js"
export * from "./DetailWoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports